import styled from 'styled-components';
import { theme } from 'consts/theme';

export const StyledHeaderSubtitleWrapper = styled.div`
  color: ${theme.colors.white};
  font-size: 16px;
  font-weight: 500;
  height: 30px;
  min-width: 220px;
  text-align: center;
`;
